module.exports = __webpack_public_path__ + "static/media/SubCategoriesIcon.fdcf61ea.svg";